/**
 * Llamadas de las cotizaciones del backoffice (COT-01).
 */
import type {
  Cotizacion,
  CotizacionResumen,
  CrearCotizacionDto,
  FiltrosCotizacionesDto,
  Paginado,
} from '@bandu/compartido';

import { guardarArchivo } from '../utilidades/guardar-archivo';
import { nombreArchivoCotizacion } from '../utilidades/cotizacion';
import { pedir, pedirArchivo } from './cliente-api';

export function obtenerCotizaciones(
  filtros: FiltrosCotizacionesDto,
  senal?: AbortSignal,
): Promise<Paginado<CotizacionResumen>> {
  return pedir<Paginado<CotizacionResumen>>('/admin/cotizaciones', {
    parametros: { termino: filtros.termino, pagina: filtros.pagina, porPagina: filtros.porPagina },
    ...(senal ? { senal } : {}),
  });
}

export function obtenerCotizacion(id: number, senal?: AbortSignal): Promise<Cotizacion> {
  return pedir<Cotizacion>(`/admin/cotizaciones/${id}`, { ...(senal ? { senal } : {}) });
}

export function crearCotizacion(datos: CrearCotizacionDto): Promise<Cotizacion> {
  return pedir<Cotizacion>('/admin/cotizaciones', { metodo: 'POST', cuerpo: datos });
}

export function eliminarCotizacion(id: number): Promise<void> {
  return pedir<void>(`/admin/cotizaciones/${id}`, { metodo: 'DELETE' });
}

/** Pide el PDF (se arma en el momento, no se guarda) y lo deja en las descargas. */
export async function descargarPdfCotizacion(
  cotizacion: Pick<Cotizacion, 'id' | 'numero' | 'cliente'>,
): Promise<void> {
  const pdf = await pedirArchivo(`/admin/cotizaciones/${cotizacion.id}/pdf`);
  guardarArchivo(pdf, nombreArchivoCotizacion(cotizacion));
}
